import { Link } from "react-router-dom";

import classes from "./Footer.module.css";

const LegalLinks = [
  { name: "Terms & Conditions", to: "/terms-and-conditions" },
  { name: "Contact Us", to: "/contact-us" },
  // { name: "Privacy Policy", to: "/information" },
];

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <div className={classes.footerContent}>
        <div className={classes.brandColumn}>
          <h2>Sovereign Auction</h2>
          <p>
            A trusted marketplace for bidding across vehicles, assets,
            equipment, and more with clear account, deposit, and auction flows.
          </p>
        </div>
      </div>

      <div className={classes.footerBottom}>
        <p>Copyright Sovereign Auction © {new Date().getFullYear()}</p>
        <div>
          {LegalLinks.map((link) => (
            <Link key={link.name} to={link.to}>
              {link.name}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
